var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"bc644f2abbf0b49e0f05d902041a2d911d53d6d1"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["fontvisual"]={id:"bc644f2abbf0b49e0f05d902041a2d911d53d6d1"};
      